/** @format */

import React, { ChangeEvent, useEffect, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import useSystemLanguage from '../../../modules/language/hooks/useSystemLanguage';
import { SimpleSelect } from '../../../components/Adescom/SimpleSelect';
import PlatformResellerInterface from '../../../interfaces/platform/PlatformResellerInterface';
import { REQUEST_STATE } from '../../../helpers/RequestHelper';
import { PlatformResellerSendType } from '../PlatformResellerModify';
import CustomMultiSelect from '../../../components/Form/CustomMultiSelect';
import useResellerAvailableSystemLanguages from '../../../modules/language/hooks/useResellerAvailableSystemLanguages';
import PlatformResellerCurrency from './PlatformResellerCurrency';
import PlatformResellerInvoiceLanguage from './PlatformResellerInvoiceLanguage';
import { Auth } from '../../../modules/auth/Auth';
import PlatformResellerVat from './PlatformResellerVat';
import PlatformResellerCountryCode from './PlatformResellerCountryCode';

interface PlatformResellerInvoicingPropsInterface {
    platformResellerId: string | null | undefined;
    platformReseller: PlatformResellerInterface | PlatformResellerSendType;
    changeCurrencyCallback: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    changeInvoiceLanguageCallback: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    isOPL: boolean;
    changeVatCallback: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    changeCountryCodeCallback: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const PlatformResellerInvoicing: React.FC<PlatformResellerInvoicingPropsInterface> = (props) => {
    return (
        <GridContainer spacing={1}>
            <GridItem xs={4}>
                <PlatformResellerCurrency
                    platformResellerId={props.platformResellerId}
                    platformReseller={props.platformReseller}
                    changeCurrencyCallback={props.changeCurrencyCallback}
                />
            </GridItem>
            <GridItem xs={4}>
                <PlatformResellerInvoiceLanguage
                    platformResellerId={props.platformResellerId}
                    platformReseller={props.platformReseller}
                    changeInvoiceLanguageCallback={props.changeInvoiceLanguageCallback}
                />
            </GridItem>
            {props.isOPL && Auth.isRootReseller() && (
                <GridItem xs={4}>
                    <PlatformResellerVat
                        platformReseller={props.platformReseller}
                        platformResellerId={props.platformResellerId}
                        changeVatCallback={props.changeVatCallback}
                    />
                    {/*        <div>*/}
                    {/*            <SimpleSelect*/}
                    {/*                label={'platform_reseller:pr.vat'}*/}
                    {/*                required={true}*/}
                    {/*                elements={[*/}
                    {/*                    { name: '23%', value: 23 },*/}
                    {/*                    // { name: '8%', value: 8 },*/}
                    {/*                    { name: '0%', value: 0 },*/}
                    {/*                    // { name: '0POZA', value: -2 },*/}
                    {/*                    { name: 'ZW', value: -1 },*/}
                    {/*                ]}*/}
                    {/*                callback={(e): void => {*/}
                    {/*                    setStateForOutput(e?.target.value, CustomItemType.Vat);*/}
                    {/*                }}*/}
                    {/*                dispatchName={'test'}*/}
                    {/*                selectedValue={outputObject?.vat}*/}
                    {/*            />*/}
                    {/*        </div>*/}
                </GridItem>
            )}
            {props.isOPL && Auth.isRootReseller() && (
                <GridItem xs={4}>
                    <PlatformResellerCountryCode
                        platformReseller={props.platformReseller}
                        platformResellerId={props.platformResellerId}
                        changeCountryCodeCallback={props.changeCountryCodeCallback}
                    />
                </GridItem>
            )}
        </GridContainer>
    );
};

export default PlatformResellerInvoicing;
